export default {
  default: () => import("/builds/webcontact/lossburg/layouts/default.vue"),
  gemeinschaftsschule: () => import("/builds/webcontact/lossburg/layouts/gemeinschaftsschule.vue")
}